import React from "react";

const Textarea = ({ field, form, label, placeholder, disabled, error }) => {
  return (
    <div className="mb-4">
      {label && (
        <label className="block text-gray-700 text-sm font-bold mb-2">
          {label}
        </label>
      )}
      <textarea
        className={`w-full p-2 text-[12px] text-[#4F2532] border-[1px] placeholder:text-[#B8A7AD] border-[#4F25321A] font-[Medium1] focus-visible:outline-[#EFB6B6]  rounded-md focus:outline-none ${
          error ? "border-red-500" : ""
        }`}
        {...field}
        placeholder={placeholder}
        disabled={disabled}
        style={{ minHeight: "150px", maxHeight: "200px", overflow: "auto" }}
      />
      {error && <div className="text-red-500 text-[12px] mt-2">{error}</div>}
    </div>
  );
};

export default Textarea;
